// extracted by mini-css-extract-plugin
export var chevron = "_1e-d";
export var disabled = "_1e-b";
export var error = "_1e-c";
export var hideBorder = "_1e-1";
export var icon = "_1e-e";
export var input = "_1e-0";
export var large = "_1e-f";
export var open = "_1e-9";
export var placeholder = "_1e-a";
export var regular = "_1e-5";
export var singleRowInput = "_1e-2";
export var singleSelectInput = "_1e-3 _1e-0";
export var small = "_1e-4";
export var spinnerContainer = "_1e-i";
export var tag = "_1e-7";
export var tagsContainer = "_1e-8";
export var tagsInput = "_1e-6 _1e-0";
export var xSmall = "_1e-g";
export var xxSmall = "_1e-h";